import Vue from "vue";
import VueRouter from "vue-router";

import roleGuard from "./service/role-guard.js";
import { captureRef } from "./utils/referral";

import login from "./views/auth/login.vue";
import forgotPassword from "./views/auth/forgot-password.vue";
//import endOfTime from "./views/auth/end-of-time.vue";
import contractInfo from "~/src/views/auth/contract-info.vue";
import contractInfo2024 from "~/src/views/auth/contract-info2024.vue";

import Home from "./views/Home.vue";
//import main from "./views/client/main.vue";
import application from "./views/client/application.vue";
import application2 from "./views/client/application-2.vue";
//import allowance from "./views/client/allowance.vue";
import appeal from "./views/client/appeal.vue";
import personalInfo from "./views/client/personal-info.vue";
import faq from "./views/client/faq.vue";
import help from "./views/client/help.vue";
import statistics from "./views/client/statistics.vue";
//import result from "./views/client/result.vue";

import Admin from "./views/Admin.vue";
import adminApplications from "./views/admin/admin-applications.vue";
import adminApplicationShow from "./views/admin/admin-application-show.vue";
import adminMasters from "./views/admin/admin-masters.vue";
import adminMasterShow from "./views/admin/admin-master-show.vue";
import adminMessages from "./views/admin/admin-messages.vue";
import adminMembers from "./views/admin/admin-members.vue";
import adminCountries from "./views/admin/admin-countries.vue";
import adminRegions from "./views/admin/admin-regions.vue";
import adminAreas from "./views/admin/admin-areas.vue";
import adminSchools from "./views/admin/admin-schools.vue";
import adminFaculties from "./views/admin/admin-faculties.vue";
import adminReferralEmployees from "./views/admin/admin-referral-employees.vue";
import adminReferralEmployeeShow from "./views/admin/admin-referral-employee-show.vue";
import adminStudentReferrals from "./views/admin/admin-student-referrals.vue";
import adminDormitory2026 from "./views/admin/admin-dormitory-2026.vue";
import adminStudentReferralShow from "./views/admin/admin-student-referral-show.vue";
import adminCallMarkaz from "./views/admin/admin-call-markaz.vue";
import adminCallMarkazShow from "./views/admin/admin-call-markaz-show.vue";
import adminEducationTypes from "./views/admin/admin-education-types.vue";
import adminEducationLanguage from "./views/admin/admin-education-language.vue";
import adminSciences from "./views/admin/admin-sciences.vue";
import adminCertificates from "./views/admin/admin-certificates.vue";
import adminDisabilities from "./views/admin/admin-disabilities.vue";
import adminsSchoolTypes from "./views/admin/admin-school-types.vue";
import adminExportImport from "./views/admin/admin-export-import.vue";
import adminAllowance from "./views/admin/admin-allowance.vue";
import adminResult from "./views/admin/admin-result.vue";
import adminFile from "./views/admin/admin-file.vue";
import adminAppicationsPaid from "~/src/views/admin/admin-applications-paid.vue";
import adminApplicationPaidShow from "~/src/views/admin/admin-application-paid-show.vue";
import adminAddNewStudent from "~/src/views/admin/admin-add-new-student.vue";
import adminApplicationPaid2023Show from "~/src/views/admin/admin-application-paid2023-show.vue";
import adminContractStatistics from "~/src/views/admin/admin-contract-statistics.vue";
import adminContracts2022 from "~/src/views/admin/admin-contracts-2022.vue";
import adminContract2022Show from "~/src/views/admin/admin-contract-2022-show.vue";
import adminContracts2023 from "~/src/views/admin/admin-contracts-2023.vue";
import adminContracts2024 from "~/src/views/admin/admin-contracts-2024.vue";
import adminContract2024Show from "~/src/views/admin/admin-contract-2024-show.vue";
import adminContracts2025 from "~/src/views/admin/admin-contracts-2025.vue";
import adminContract2025Show from "~/src/views/admin/admin-contract-2025-show.vue";
import adminContracts2026 from "~/src/views/admin/admin-contracts-2026.vue";
import adminContract2026Show from "~/src/views/admin/admin-contract-2026-show.vue";
import adminDropped2022 from "~/src/views/admin/admin-dropped-2022.vue";
import adminDropped2023 from "~/src/views/admin/admin-dropped-2023.vue";
import adminDropped2024 from "~/src/views/admin/admin-dropped-2024.vue";
import adminDropped2025 from "~/src/views/admin/admin-dropped-2025.vue";
import adminDropped2026 from "~/src/views/admin/admin-dropped-2026.vue";
import adminInactive2025 from "~/src/views/admin/admin-inactive-2025.vue";
import adminInactive2026 from "~/src/views/admin/admin-inactive-2026.vue";
import adminOlimpiada2024 from "~/src/views/admin/admin-olimpiada2024.vue";
import adminOlimpiada2024Show from "~/src/views/admin/admin-olimpiada-2024-show.vue";

import adminGroups from "~/src/views/admin/admin-groups.vue";
import adminGroupShow from "~/src/views/admin/admin-group-show.vue";

import archive from "~/src/views/admin/archive.vue";
import adminTeachers from "~/src/views/admin/admin-teachers.vue";
import lessonUpload from "~/src/views/admin/lesson/lesson-upload.vue";
import lessonData from "~/src/views/admin/lesson/lesson-data.vue";
import adminLogs from "~/src/views/admin/AdminLogs.vue";
import adminBitrixMonitor from "~/src/views/admin/AdminBitrixMonitor.vue";
import adminPermission from "~/src/views/admin/admin-permission.vue";
import adminPromotion from "~/src/views/admin/admin-promotion.vue";
import adminExamQuestions from "./views/admin/admin-exam-questions.vue";
import adminExamSciences from "./views/admin/admin-exam-sciences.vue";
import adminExamResults from "./views/admin/admin-exam-results.vue";

const adminContractTemplates = () => import("./views/admin/admin-contract-templates.vue");
const adminSmsSettings = () => import("./views/admin/admin-sms-settings.vue");
const adminActionRestrictions = () => import("./views/admin/admin-action-restrictions.vue");

import dashboard from "~/src/views/admin/Dashboard.vue";
import paymentExplorer from "~/src/views/admin/PaymentsExplorer.vue";
import adminMain from "~/src/views/admin/admin-main.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: login,
  },
  /*{
    path: "/end-of-time",
    component: endOfTime,
  },*/
  {
    path: "/forgot-password",
    component: forgotPassword,
  },
  {
    path: "/contract-info/:id",
    component: contractInfo,
  },
  {
    path: "/contract-info2024/:id",
    component: contractInfo2024,
  },
  {
    path: "/home",
    component: Home,
    beforeEnter: roleGuard,
    children: [
      {
        path: "/",
        component: application,
      },
      {
        path: "/application-2",
        component: application2,
      },
      /*{
        path: "/allowance",
        component: allowance,
      },*/
      {
        path: "/appeal",
        component: appeal,
      },
      {
        path: "/personal-info",
        component: personalInfo,
      },
      {
        path: "/faq",
        component: faq,
      },
      {
        path: "/help",
        component: help,
      },
      {
        path: "/statistics",
        component: statistics,
      },
      /* {
        path: "/result",
        component: result,
      },*/
    ],
  },
  {
    path: "/dashboard",
    component: Admin,
    beforeEnter: roleGuard,
    meta: {
      keepAlive: true,
    },

    children: [
      {
        path: "/",
        component: dashboard,
      },
      {
        path: "/payments",
        component: paymentExplorer,
      },
      {
        path: "/panels",
        component: adminMain,
      },
      {
        path: "/applications",
        component: adminApplications,
      },
      {
        path: "/olimpiada2024",
        component: adminOlimpiada2024,
      },
      {
        path: "/contract_2022_2023",
        component: adminAppicationsPaid,
      },
      {
        path: "/contract_2022_2023_v2",
        component: adminContracts2022,
      },
      {
        path: "/contract_2023_2024",
        component: adminContracts2023,
      },
      {
        path: "/contract_2024_2025",
        component: adminContracts2024,
      },
      {
        path: "/contract_2025_2026",
        component: adminContracts2025,
        meta: {
          keepAlive: true,
        }
      },
      {
        path: "/contract_2026_2027",
        component: adminContracts2026,
        meta: {
          keepAlive: true,
        }
      },
      {
        path: "/dropped_2022_2023",
        component: adminDropped2022,
        meta: { keepAlive: true },
      },
      {
        path: "/dropped_2023_2024",
        component: adminDropped2023,
        meta: { keepAlive: true },
      },
      {
        path: "/dropped_2024_2025",
        component: adminDropped2024,
        meta: { keepAlive: true },
      },
      {
        path: "/dropped_2025_2026",
        component: adminDropped2025,
        meta: { keepAlive: true },
      },
      {
        path: "/dropped_2026_2027",
        component: adminDropped2026,
        meta: { keepAlive: true },
      },
      {
        path: "/inactive_2025_2026",
        component: adminInactive2025,
        meta: { keepAlive: true },
      },
      {
        path: "/inactive_2026_2027",
        component: adminInactive2026,
        meta: { keepAlive: true },
      },
      {
        path: "/application-show/:id",
        component: adminApplicationShow,
      },
      {
        path: "/olimpiada2024-show/:id",
        component: adminOlimpiada2024Show,
      },
      {
        path: "/contract_2022_2023-show/:id",
        component: adminApplicationPaidShow,
      },
      {
        path: "/contract_2022_2023_v2-show/:id",
        component: adminContract2022Show,
      },
      {
        path: "/contract_2023_2024-show/:id",
        component: adminApplicationPaid2023Show,
      },
      {
        path: "/contract_2024_2025-show/:id",
        component: adminContract2024Show,
      },
      {
        path: "/contract_2025_2026-show/:id",
        component: adminContract2025Show,
        meta: { keepAlive: true }
      },
      {
        path: "/contract_2026_2027-show/:id",
        component: adminContract2026Show,
        meta: { keepAlive: true }
      },
      {
        path: "/add-new-student",
        component: adminAddNewStudent,
      },
      {
        path: "/contract-statistics",
        component: adminContractStatistics,
      },
      {
        path: "/messages",
        component: adminMessages,
      },
      {
        path: "/masters/:year",
        component: adminMasters,
      },
      {
        path: "/masters-show/:id",
        component: adminMasterShow,
      },
      {
        path: "/members",
        component: adminMembers,
      },
      {
        path: "/countries",
        component: adminCountries,
      },
      {
        path: "/regions",
        component: adminRegions,
      },
      {
        path: "/areas",
        component: adminAreas,
      },
      {
        path: "/schools",
        component: adminSchools,
      },
      {
        path: "/faculties",
        component: adminFaculties,
      },
      {
        path: "/qabul-xodimlar-2026-2027",
        component: adminReferralEmployees,
      },
      {
        path: "/qabul-xodimlar-2026-2027/:id",
        component: adminReferralEmployeeShow,
      },
      {
        path: "/talaba-referallari-2026-2027",
        component: adminStudentReferrals,
      },
      {
        path: "/yotoqxona_2026_2027",
        component: adminDormitory2026,
        meta: { keepAlive: true },
      },
      {
        path: "/talaba-referallari-2026-2027/:id",
        component: adminStudentReferralShow,
      },
      {
        path: "/call-markaz-2026-2027",
        component: adminCallMarkaz,
      },
      {
        path: "/call-markaz-2026-2027/:id",
        component: adminCallMarkazShow,
      },
      {
        path: "/education-types",
        component: adminEducationTypes,
      },
      {
        path: "/education-language",
        component: adminEducationLanguage,
      },
      {
        path: "/sciences",
        component: adminSciences,
      },
      {
        path: "/certificates",
        component: adminCertificates,
      },
      {
        path: "/disabilities",
        component: adminDisabilities,
      },
      {
        path: "/school-types",
        component: adminsSchoolTypes,
      },
      {
        path: "/export-import",
        component: adminExportImport,
      },
      {
        path: "/allowance/:id",
        component: adminAllowance,
      },
      {
        path: "/result/:id",
        component: adminResult,
      },
      {
        path: "/file/:id/:mode?",
        component: adminFile,
      },
      {
        path: "/groups",
        component: adminGroups,
      },
      {
        path: "/group-show/:id",
        component: adminGroupShow,
      },
      {
        path: "/archive",
        component: archive,
      },
      {
        path: "/teachers",
        component: adminTeachers,
      },
      {
        path: "/lesson-upload",
        component: lessonUpload,
      },
      {
        path: "/lesson-data/:uploadId",
        component: lessonData,
      },
      {
        path: "/logs",
        component: adminLogs,
      },
      {
        path: "/bitrix-monitor",
        component: adminBitrixMonitor,
      },
      {
        path: "/permission",
        component: adminPermission,
      },
      {
        path: "/promotion",
        component: adminPromotion,
      },
      {
        path: "/exam-questions",
        component: adminExamQuestions,
      },
      {
        path: "/exam-sciences",
        component: adminExamSciences,
      },
      {
        path: "/exam-results",
        component: adminExamResults,
      },
      {
        path: "/contract-templates",
        component: adminContractTemplates,
      },
      {
        path: "/sms-settings",
        component: adminSmsSettings,
      },
      {
        path: "/action-restrictions",
        component: adminActionRestrictions,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// First-touch capture of the referral token (?ref=...) on any entry into the app.
router.beforeEach((to, from, next) => {
  captureRef(to.query);
  next();
});

export default router;
